<template>
  <v-dialog
    v-model="dialog"
    :width="step == 0? '510px': '330px'">
    <div class="dialog-container">
      <template v-if="step == 0">
        <h3>Mark As Issuing</h3>
        <p>This policy will no longer be adjustable. Continue?</p>

        <el-form
          v-if="form.product_id == 11&&!isHzmb"
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="form-item">
            <span>Cover Note(Optional)</span>
            <file-container
              :fileData="formData.cvr_pdf"
              :edit="true"
              titleName= "Cover Note(Optional)"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
          </div>
          <div
            v-if="formData.cvr_pdf"
            class="form-item">
            <span>Cover Note No.</span>
            <el-form-item
              ref="cvr_nt_no"
              prop="cvr_nt_no">
              <v-input v-model="formData.cvr_nt_no" />
            </el-form-item>

          </div>
        </el-form>

        <div class="dialog-footer">
          <v-button @click="dialog = false">Cancel</v-button>
          <v-button
            type="primary"
            @click="onContinue">Continue</v-button>
        </div>
      </template>
      <template v-else>
        <send-email-sms
          ref="send-email-sms"
          :form="form"
          :is-fina="isFina"
          :initContent="form.cover_note_url_data"
          :init-referrer-content="form.referrer_cover_note_url_data"
          :emailListTitle="emailListTitle"
          :emailTitle="emailTitle"
          :orderId="orderId"
          :show-referrer="isFina"
          @cancel="dialog = false"
          @send="onSend"
          @skip="onSkip" />
      </template>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {
  orderIssueIssuing,
  sendOrderIssueIssuingNotice } from '@/api/order'
import SendEmailSms from './send-email-sms'

export default {
  name: 'MarkAsIssuingDialog',
  components: {
    SendEmailSms
  },
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    changeUploadData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      step: 0,
      formData: {
        cvr_nt_no: '',
        cvr_pdf_path_id: '',
        cvr_pdf_path: '',
        cvr_pdf: null,
      },
      sendFormData: {
        content: ''
      }
    }
  },
  computed:{
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform == 2
    },
    emailListTitle(){
      return this.form.cover_note_url_list_title || ''
    },
    emailTitle(){
      return this.form.cover_note_url_title || ''
    },
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id==15
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        if(val) {
          const { cvr_nt_no } = this.form
          const { file } = this.changeUploadData
          const {path,id} = file||{}
          this.formData.cvr_pdf = file
          this.formData.cvr_pdf_path_id = id
          this.formData.cvr_pdf_path = path
          if(cvr_nt_no) {
            this.formData.cvr_nt_no = cvr_nt_no
          }
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.step = 0
      this.dialog = !this.dialog
    },
    handlerUploadSuccess({ data, result }) {
      this.$set(this.formData, 'cvr_pdf', data)
      this.$set(this.formData, 'cvr_pdf_path_id', data.id)
      this.$set(this.formData, 'cvr_pdf_path', data.path)
    },
    handlerDeleteFile() {
      this.$set(this.formData, 'cvr_pdf', null)
      this.$set(this.formData, 'cvr_pdf_path_id', '')
      this.$set(this.formData, 'cvr_pdf_path', '')
    },
    onContinue() {
      if(this.form.product_id != 11||this.isHzmb) {
        // this.step = 1
        this.onSkip()
        return
      }
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          //   this.network().orderIssueIssuing()
          this.step = 1
        }
        else {
          console.log(rules)
        }
      })
    },
    onSend(data) {
      //   this.$refs['send-form'].validate((valid, rules) => {
      //     if(valid) {
      let {content,referrer_send,referrer_content,customer_send} =data
      let params = {
        content,
        referrer_content,
        is_send:1
      }
      if(!customer_send) delete params.content
      if(!referrer_send) delete params.referrer_content
      this.sendFormData = params
      this.network().orderIssueIssuing('send')
    //     }
    //     else {
    //       console.log(rules)
    //     }
    //   })
    },
    onSkip() {
      this.sendFormData = {
        is_send:0
      }
      this.network().orderIssueIssuing()
    },
    network() {
      return {
        orderIssueIssuing: async (type) => {
          let params = {
            order_id: this.orderId,
            ...this.sendFormData
          }
          if(this.form.product_id == 11) {
            if(this.formData.cvr_pdf) {
              params = {
                ...params,
                ...this.formData
              }
            }
          }
          const { data } = await orderIssueIssuing(params)

          // if(type == 'send') {
          //   this.network().sendOrderIssueIssuingNotice()
          // }
          // else {
          //   this.dialog = false
          //   this.$emit('success')
          // }
          this.dialog = false
          this.$emit('success')
        },
        sendOrderIssueIssuingNotice: async () => {
          const { data } = await sendOrderIssueIssuingNotice({
            order_id: this.orderId,
            ...this.sendFormData
          })
          this.dialog = false
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      h3 {
        padding-bottom: 5px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: bold;
              font-size: 16px;
          }
      }
    }
</style>
